import { Module } from '@nestjs/common';
import { FacturasModule } from 'src/facturas/facturas.module';
import { SyncController } from './sync.controller';
import { SyncService } from './sync.service';

@Module({
  imports: [FacturasModule],
  controllers: [SyncController],
  providers: [SyncService],
})
export class SyncModule {}
